import React from "react";

const ComingSoon = () => (
    <div style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        background: "#f5f6fa"
    }}>
        <h1 style={{ fontSize: "3rem", color: "#222" }}>Coming Soon</h1>
        <p style={{ fontSize: "1.25rem", color: "#555" }}>
            The Organizations page is under construction. Stay tuned!
        </p>
    </div>
);

export default ComingSoon;